import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyALPZ6Vh80f2WNxKR7AMcpShxMoDftOnTI",
  authDomain: "submeta-93327.firebaseapp.com",
  projectId: "submeta-93327",
  storageBucket: "submeta-93327.firebasestorage.app",
  messagingSenderId: "722409898617",
  appId: "1:722409898617:web:44591f73519891ca974aa8",
  measurementId: "G-49GSE2W7FW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Connect to the emulator during development
if (process.env.NODE_ENV === "development") {
  console.log("EMULATING");
  connectFunctionsEmulator(functions, "localhost", 5001);
}
